import { isNotDefined } from "../utils";

const defaultOptions = {
  windowSize: 20,
};

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize } = options;

    let totalUp = 0;
    let totalDown = 0;

    return data.map((d, i) => {
      const close = d.close;
      const open = d.open;

      if (isNotDefined(close) || isNotDefined(open)) {
        return undefined;
      }

      // Calculate intraday difference (Close - Open)
      const diff = close - open;

      // Accumulate up and down movements
      if (diff > 0) {
        totalUp += diff;
      } else {
        totalDown -= diff; // Note: -= because diff is negative
      }

      // Remove oldest bar from window if we exceed the period
      if (i >= windowSize) {
        const oldClose = data[i - windowSize].close;
        const oldOpen = data[i - windowSize].open;

        if (!isNotDefined(oldClose) && !isNotDefined(oldOpen)) {
          const pDiff = oldClose - oldOpen;
          if (pDiff > 0) {
            totalUp -= pDiff;
          } else {
            totalDown += pDiff; // Note: += because pDiff is negative
          }
        }
      }

      // Calculate IMI once we have enough data
      if (i < windowSize - 1) {
        return undefined;
      }

      const total = totalUp + totalDown;
      if (total === 0) {
        return 50; // Neutral if no movement
      }

      const imi = 100 * (totalUp / total);
      return imi;
    });
  }

  calculator.undefinedLength = () => options.windowSize - 1;

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
